export class NoAvailableHoursError extends Error {
  constructor() {
    super('Horário indisponível')
    this.name = 'NOT_AVAILABLE_HOUR'
  }
}
